import Api from './axios'

const measurementTypeService = {
    async getMeasurementTypes() {
        return await Api.get('/measurement-types/')
    }
}

export default measurementTypeService;